import { formatArea } from '../../utils/formatters';

interface SelectionSummaryProps {
  selectedCount: number;
  selectedAreaM2: number;
  onClear: () => void;
}

export function SelectionSummary({ selectedCount, selectedAreaM2, onClear }: SelectionSummaryProps) {
  if (selectedCount <= 0) {
    return null;
  }

  return (
    <aside className="selection-summary matte-frame">
      <div className="selection-summary-meta">
        <span className="selection-summary-label">已选地块</span>
        <span className="selection-summary-count">{selectedCount} 个</span>
      </div>
      <div className="selection-summary-value">{formatArea(selectedAreaM2)} ㎡</div>
      <button type="button" className="selection-clear-btn" aria-label="清空选择" onClick={onClear}>
        X
      </button>
    </aside>
  );
}
